export default {"src":"/_next/static/media/design-tools-icon.01e34e79.svg","height":49,"width":50};